import Api from '../../../../services/api';
import moment from 'moment'
import React, { useEffect, useState } from 'react';
import MaskedInput from 'react-input-mask'
import { message, Form, Spin, Select } from 'antd';
import { Input, Button, InputNumber } from 'antd';
import { useParams, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as PermissaoAction from '../../../../redux/actions/permissao';
import MaskedTextInput from 'react-text-mask'
import { IResponseErrorEnderecoAPI, buscarEnderecoApi, validarCEP } from '../../../../utils/cept';
import { estadoEntradaBrasilService } from '../../../../services/Estado-Entrada-Brasil-Service/estado-entrada-brasil-service';
import { modoEntradaService } from '../../../../services/Modo-Entrada-Service/modo-entrada-service';
import { municipioEntradaBrasilService } from '../../../../services/Municipio-Entrada-Brasil-Service/municipio-entrada-brasil-service';
import { pontoFiscalizacaoService } from '../../../../services/Ponto-Fiscalizacao-Service/ponto-fiscalizacao-service';
import { LocalidadeService } from '../../../../services/Localidade-Service/localidade-service';

interface props {
    dados: any;
    permissao?: any
}

const DadosImigracao: React.FC<props> = (props) => {

    const [loading, setLoading] = useState(false);
    const { id } = useParams<Record<string, string | undefined>>()
    const { agendamentoID } = useParams<Record<string, string | undefined>>()
    const [form] = Form.useForm();
    const [dadosImigracaoID, setDadosImigracaoID] = useState<number | undefined>();
    const { Search } = Input;
    const [permissaoUserEditar, setPermissaoUserEditar] = useState<boolean>(false);
    const [modoEntrada, setModoEntrada] = useState<any[]>([]);
    const [estadoEntradaBrasil, setEstadoEntradaBrasil] = useState<any[]>([]);
    const [estadoEntradaBrasilSelected, setEstadoEntradaBrasilSelected] = useState<boolean>(false);
    const [municipioEntradaBrasil, setMunicipioEntradaBrasil] = useState<any[]>([]);
    const [municipioEntradaBrasilSelected, setMunicipioEntradaBrasilSelected] = useState<boolean>(false);
    const [pontoFiscalizacao, setPontoFiscalizacao] = useState<any[]>([]);
    const [municipioEntradaMS, setMunicipioEntradaMS] = useState<any[]>([]);
    const [municipioEntradaMSSelected, setMunicipioEntradaMSSelected] = useState<boolean>(false);
    // const [pontoFiscalizacaoMS, setPontoFiscalizacaoMS] = useState<any[]>([]);
    const [paises, setPaises] = useState<any[]>([]);
    let location = useLocation();
    var currentLocation = location.pathname

    let paths = currentLocation.split('/');

    useEffect(() => {


        if (JSON.stringify(props.dados) === '{}') {
            getEstadoEntradaBrasil();
            getMunicipioEntradaMS();
            getModoEntrada();
        } else {
            getEstadoEntradaBrasil();
            getMunicipioEntradaBrasilPorEstadoID(props.dados?.estadoEntradaBrasilID)
            getPontoFiscalizacaoPorMunicipioID(props.dados?.municipioEntradaBrasilID, false)
            // getPontoFiscalizacaoPorMunicipioID(props.dados?.municipioEntradaMSID, true)
            getMunicipioEntradaMS();
            getModoEntrada();
        }
        let dataEntradaNoBrasil = new Date(Date.parse(props.dados?.entradaNoBrasil)).toLocaleDateString();

        form.setFieldsValue({
            ultimoPais: props.dados?.ultimoPais,
            entradaNoBrasil: props.dados?.entradaNoBrasil ? dataEntradaNoBrasil : null,
            municipioEntradaBrasilID: props.dados?.municipioEntradaBrasilID,
            estadoEntradaBrasilID: props.dados?.estadoEntradaBrasilID,
            pontoFiscalizacaoBrasilID: props.dados?.pontoFiscalizacaoBrasilID,
            municipioEntradaMSID: props.dados?.municipioEntradaMSID,
            // pontoFiscalizacaoMSID: props.dados?.pontoFiscalizacaoMSID,
            enderecoRua: props.dados?.enderecoRua,
            enderecoBairro: props.dados?.enderecoBairro,
            enderecoComplemento: props.dados?.enderecoComplemento,
            enderecoCidade: props.dados?.enderecoCidade,
            email: props.dados?.email,
            enderecoNumero: props.dados?.enderecoNumero,
            cep: props.dados?.cep,
            telefone: props.dados?.telefone
        });

        setDadosImigracaoID(props.dados?.dadosImigracaoID);
        if (paths[4] == "agendamento" && props.permissao[0].permissaoAcesso?.editar == false) {

            setPermissaoUserEditar(true);

        } else {
            setPermissaoUserEditar(props.permissao[0].permissaoAcesso?.editar);
        }
         buscaPaises();

    }, [props.dados])



    const buscaPaises = async () =>{
        
       await LocalidadeService.getPaises(setLoading).then((res)=> setPaises(res));

    }

    const getEstadoEntradaBrasil = () => {
        setLoading(true)
        estadoEntradaBrasilService.getAllAtivos()
            .then((response) => {
                if (response.data)
                    setEstadoEntradaBrasil(response.data)
            })
            .finally(() => {
                setLoading(false);
            })
            .catch(() => {
                message.error("Falha na requisição dos Estados Entrada Brasil");
                setLoading(false);
            })
    }

    const getMunicipioEntradaBrasilPorEstadoID = (estadoID: any, resetCampo: boolean = false) => {
        if (estadoID != null && estadoID != undefined) {
            setLoading(true)
            municipioEntradaBrasilService.getAllAtivosPorEstado(estadoID)
                .then((response) => {
                    if (response.data) {
                        setMunicipioEntradaBrasil(response.data)
                        setEstadoEntradaBrasilSelected(true)
                        if (resetCampo) {
                            setMunicipioEntradaBrasilSelected(false)
                            form.setFieldsValue({ municipioEntradaBrasilID: null, pontoFiscalizacaoBrasilID: null })
                        }
                    }
                })
                .finally(() => {
                    setLoading(false);
                })
                .catch(() => {
                    message.error("Falha na requisição dos Município de Entrada");
                    setLoading(false);
                    setEstadoEntradaBrasilSelected(false)
                })
        }
    }

    const getMunicipioEntradaMS = () => {
        setLoading(true)
        municipioEntradaBrasilService.getAllAtivosMS()
            .then((response) => {
                if (response.data) {
                    setMunicipioEntradaMS(response.data)
                }
            })
            .finally(() => {
                setLoading(false);
            })
            .catch(() => {
                message.error("Falha na requisição dos Município de Entrada");
                setLoading(false);
            })
    }

    const getPontoFiscalizacaoPorMunicipioID = (municipioID: any, ehMS: boolean, resetCampo: boolean = false) => {

        if (municipioID != null && municipioID != undefined) {
            setLoading(true)
            pontoFiscalizacaoService.getAllAtivosPorMunicipio(municipioID)
                .then((response) => {
                    if (response.data) {
                        if (ehMS) {
                            // setMunicipioEntradaMSSelected(true)
                            setPontoFiscalizacao(response.data)
                            setMunicipioEntradaBrasilSelected(true)
                            if (resetCampo) {
                                // form.setFieldsValue({ pontoFiscalizacaoMSID: null })
                                form.resetFields(['pontoFiscalizacaoBrasilID'])

                            }
                        }
                        if (!ehMS) {
                            setPontoFiscalizacao(response.data)
                            setMunicipioEntradaBrasilSelected(true)
                            // if (resetCampo) {
                            //     form.resetFields({ pontoFiscalizacaoBrasilID: null })
                            // }
                        }
                    }
                })
                .finally(() => {
                    setLoading(false);
                })
                .catch((err) => {
                    message.error("Falha na requisição do Ponto Fiscalização");
                    setLoading(false);
                    // if (ehMS)
                    //     setMunicipioEntradaMSSelected(false)
                    // if (!ehMS)
                    //     setMunicipioEntradaBrasilSelected(false)
                })
        }
    }

    const getModoEntrada = () => {
        setLoading(true)
        modoEntradaService.getAllAtivos()
            .then((response) => {
                if (response.data)
                    setModoEntrada(response.data)
            })
            .finally(() => {
                setLoading(false);
            })
            .catch(() => {
                message.error("Falha na requisição dos Modo Entrada");
                setLoading(false);
            })
    }

    function toISOFormat(dateTimeString: string) {
        // Primeiro, dividimos a data completa em duas partes:
        const [DD, MM, YYYY] = dateTimeString.split('/');
        // Retornamos a data formatada em um padrão compatível com ISO:
        return `${YYYY}-${MM}-${DD}`;
    }

    const validarData = (_: any, value: { number: number }) => {
        if (form.getFieldValue("entradaNoBrasil") != undefined) {
            let result, data;
            let dataFormatada = toISOFormat(form.getFieldValue("entradaNoBrasil"));
            data = new Date(dataFormatada);
            result = moment(data).isValid();
            if (result == false) {
                return Promise.reject(new Error('Data inválida!'));
            }
            return Promise.resolve();
        }
        return Promise.resolve();
    };

    const submit = async (value: any) => {

        setLoading(true);
        let dataEntradaNoBrasil;
        if (value.entradaNoBrasil != undefined) {
            dataEntradaNoBrasil = value.entradaNoBrasil ? moment(value.entradaNoBrasil, "DD/MM/YYYY").format("YYYY-MM-DD") : undefined
            // dataEntradaNoBrasil = new Date(dataFormatada);
        }
        if (dadosImigracaoID != null && dadosImigracaoID != undefined) {
            await Api.put("DadosImigracao", {
                DadosImigracaoID: dadosImigracaoID,
                UltimoPais: value.ultimoPais,
                EntradaNoBrasil: dataEntradaNoBrasil,
                MunicipioEntradaBrasilID: value.municipioEntradaBrasilID,
                PontoFiscalizacaoBrasilID: value.pontoFiscalizacaoBrasilID,
                EstadoEntradaBrasilID: value.estadoEntradaBrasilID,
                MunicipioEntradaMSID: value.municipioEntradaMSID,
                // PontoFiscalizacaoMSID: value.pontoFiscalizacaoMSID,
                EnderecoRua: value.enderecoRua,
                EnderecoBairro: value.enderecoBairro,
                EnderecoComplemento: value.enderecoComplemento,
                EnderecoCidade: value.enderecoCidade,
                Email: value.email,
                EnderecoNumero: value.enderecoNumero,
                Cep: value.cep,
                DadosCadastraisID: id ? parseInt(id) : 0,
                AgendamentoID: agendamentoID ? parseInt(agendamentoID) : 0
            })
                .then((response) => {
                    message.success('Salvo com sucesso')
                })
                .catch((err) => {
                    message.error(err?.response?.data?.message ? err?.response?.data?.message : 'Falha na requisição')
                }).finally(() => {
                    setLoading(false);
                })
        }
        else {
            await Api.post("DadosImigracao", {
                UltimoPais: value.ultimoPais,
                EntradaNoBrasil: dataEntradaNoBrasil,
                MunicipioEntradaBrasilID: value.municipioEntradaBrasilID,
                PontoFiscalizacaoBrasilID: value.pontoFiscalizacaoBrasilID,
                EstadoEntradaBrasilID: value.estadoEntradaBrasilID,
                MunicipioEntradaMSID: value.municipioEntradaMSID,
                // PontoFiscalizacaoMSID: value.pontoFiscalizacaoMSID,
                EnderecoRua: value.enderecoRua,
                EnderecoBairro: value.enderecoBairro,
                EnderecoComplemento: value.enderecoComplemento,
                EnderecoCidade: value.enderecoCidade,
                Email: value.email,
                EnderecoNumero: value.enderecoNumero,
                Cep: value.cep,
                DadosCadastraisID: id ? parseInt(id) : 0,
                AgendamentoID: agendamentoID ? parseInt(agendamentoID) : 0
            })
                .then((response) => {
                    setDadosImigracaoID(response?.data?.dadosImigracao?.dadosImigracaoID);
                    message.success('Salvo com sucesso')
                })
                .catch((err) => {
                    message.error(err?.response?.data?.message ? err?.response?.data?.message : 'Falha na requisição')
                }).finally(() => {
                    setLoading(false);
                })
        }
    }


    const buscarEndereco = async () => {
        let cep = form.getFieldValue('cep')
        if (cep != null) {
            let target = cep.replace(/_|-|\\. /g, '');

            setLoading(true)
            await buscarEnderecoApi(target)
                .then((response) => {
                    form.setFieldsValue({ enderecoRua: response?.logradouro });
                    form.setFieldsValue({ enderecoBairro: response?.bairro });
                    form.setFieldsValue({ enderecoCidade: response?.localidade });

                })
                .catch((e: IResponseErrorEnderecoAPI) => {
                    if (e && e.mensagem) {
                        message.error(e.mensagem)
                    }
                })
                .finally(() => {
                    setLoading(false);
                })

        }

    }

    return (
        <div className="container">
            <div className="form-pesquisa">
                <Spin spinning={loading}>
                    <Form onFinish={submit}
                        form={form}
                        labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}

                        layout="horizontal"
                        size="middle"
                    >
                        <div className="row">
                            <div className="col-md-4">
                                <Form.Item name="email" label="E-mail"
                                    rules={[
                                        {
                                            type: 'email',
                                            message: 'A entrada não é um e-mail válido! Exemplo: texto@email.com',
                                        },
                                        {

                                            required: true,
                                            message: 'Por favor, insira um e-mail!',
                                        },
                                    ]}>
                                    <Input placeholder="Informe o e-mail "
                                        disabled={permissaoUserEditar === false}
                                    />
                                </Form.Item>
                            </div>
                            <div className="col-md-2">
                                <Form.Item name="cep" label="CEP" labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}
                                    rules={[
                                        { required: true, message: 'Por favor, insira um CEP!', },
                                        { validator: (_, value) => validarCEP(value), validateTrigger: 'onSubmit' }
                                    ]}>
                                    <MaskedTextInput
                                        name="cepInput"
                                        mask={[/\d/, /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/]}
                                        placeholder="CEP" className={"globalInput cpfMaskedInput"}
                                    >
                                    </MaskedTextInput>
                                </Form.Item>
                            </div>
                            <div className='col-md-1'>
                                <Form.Item name="buscarCep" label="Buscar">
                                    <Button type='primary' onClick={buscarEndereco}>
                                        CEP
                                    </Button>
                                </Form.Item>
                            </div>
                            <div className="col-md-3">
                                <Form.Item name="enderecoCidade" label="Cidade"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Por favor, insira uma cidade!',
                                        }
                                    ]}>
                                    <Input placeholder="Informe uma cidade "
                                        disabled={permissaoUserEditar === false}
                                    />
                                </Form.Item>
                            </div>
                            <div className="col-md-2">
                                <Form.Item name="enderecoBairro" label="Bairro"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Por favor, insira um bairros!',
                                        }
                                    ]}>
                                    <Input placeholder="Informe um bairro"
                                        disabled={permissaoUserEditar === false}
                                    />
                                </Form.Item>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6">
                                <Form.Item name="enderecoRua" label="Rua"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Por favor, insira um logradouro!',
                                        }
                                    ]}>
                                    <Input placeholder="informe um logradouro "
                                        disabled={permissaoUserEditar === false}
                                    />
                                </Form.Item>
                            </div>

                            <div className="col-md-2">
                                <Form.Item name="enderecoNumero" label="Número"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Por favor, insira o número do endereço!',
                                        }
                                    ]}>
                                    <InputNumber
                                        min={1}
                                        controls={false}
                                        placeholder="informe o número do endereço"
                                        disabled={permissaoUserEditar === false}
                                    />

                                </Form.Item>
                            </div>
                            <div className="col-md-4">
                                <Form.Item name="enderecoComplemento" label="Complemento" >
                                    <Input placeholder="informe o complemento"
                                        disabled={permissaoUserEditar === false}
                                    />
                                </Form.Item>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <Form.Item name="ultimoPais" label="Ultimo país antes do Brasil"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Por favor, insira uma informação neste campo!',
                                        }
                                    ]}>
                                    <Select
                                        showSearch
                                        optionFilterProp="children"
                                        placeholder="selecione um país"
                                        disabled={permissaoUserEditar === false}
                                    >

                                        {paises.map((p:any, index:number) => <Select.Option value={p.name?.toUpperCase()} key={`pais_${index}`}>{p?.name?.toUpperCase()}</Select.Option>)}

                                    </Select>
                                </Form.Item>
                            </div>

                            <div className="col-md-6">
                                <Form.Item name="entradaNoBrasil" label="Data de Entrada no Brasil" labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Por favor, insira uma data!',
                                            validator: validarData
                                        }
                                    ]}>
                                    <MaskedInput className="ant-input" placeholder="Informe a Data" mask="99/99/9999" />

                                    {/* <DatePicker
                                        style={{ width: '100%' }}
                                        format="DD/MM/YYYY"
                                        placeholder="01/01/1111"
                                        disabled={permissaoUserEditar === false}
                                    /> */}
                                </Form.Item>
                            </div>

                        </div >

                        <div className="row">

                            <div className="col-md-3">
                                <Form.Item name="estadoEntradaBrasilID" label="Estado de entrada no BR"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Por favor, insira uma informação neste campo!',
                                        }
                                    ]}>
                                    <Select
                                        showSearch
                                        optionFilterProp="children"
                                        placeholder="Selecione um Estado de Entrada MS"
                                        disabled={permissaoUserEditar === false}
                                        onSelect={(e: any) => getMunicipioEntradaBrasilPorEstadoID(e, true)}
                                    >

                                        {estadoEntradaBrasil.map(p => <Select.Option value={p.estadoEntradaBrasilID}>{p.nome + ' - ' + p.uf}</Select.Option>)}

                                    </Select>
                                    {/* <Input placeholder="informe um estado"
                                        disabled={permissaoUserEditar === false}
                                    /> */}
                                </Form.Item>
                            </div>

                            <div className="col-md-3">
                                <Form.Item name="municipioEntradaBrasilID" label="Município de entrada no BR"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Por favor, insira uma informação neste campo!',
                                        }
                                    ]}>
                                    <Select
                                        showSearch
                                        optionFilterProp="children"
                                        placeholder="Selecione um Município"
                                        disabled={permissaoUserEditar === false || !estadoEntradaBrasilSelected}
                                        onSelect={(e: any) => {
                                            getPontoFiscalizacaoPorMunicipioID(e, true, true);
                                        }}
                                    >
                                        {municipioEntradaBrasil.map(p => <Select.Option value={p.municipioEntradaBrasilID}>{p.nome}</Select.Option>)}

                                    </Select>
                                    {/* <Input placeholder="informe um município"
                                        disabled={permissaoUserEditar === false}
                                    /> */}
                                </Form.Item>
                            </div>

                            <div className="col-md-6">
                                <Form.Item name="pontoFiscalizacaoBrasilID" label="Ponto de Fiscalização de entrada no BR - (MODO DE ENTRADA)">
                                    <Select
                                        showSearch
                                        optionFilterProp="children"
                                        placeholder="Selecione um Ponto de Fiscalização"
                                        disabled={permissaoUserEditar === false || !municipioEntradaBrasilSelected}
                                    >
                                        {pontoFiscalizacao.map(p => <Select.Option value={p.pontoFiscalizacaoID}>{p.nome + " - (" + modoEntrada.find(m => m.modoEntradaID == p.modoEntradaID)?.descricao + ")"}</Select.Option>)}

                                    </Select>
                                    {/* <Input placeholder="informe um município"
                                        disabled={permissaoUserEditar === false}
                                    /> */}
                                </Form.Item>
                            </div>

                        </div>
                        <div className='row'>
                            <div className="col-md-6">
                                <Form.Item name="municipioEntradaMSID" label="Município de entrada no MS"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Por favor, insira uma informação neste campo!',
                                        }
                                    ]}>
                                    <Select
                                        showSearch
                                        optionFilterProp="children"
                                        placeholder="Selecione um Município"
                                        disabled={permissaoUserEditar === false}
                                        onSelect={(e: any) => {
                                            getPontoFiscalizacaoPorMunicipioID(e, true);
                                        }}
                                    >
                                        {municipioEntradaMS.map(p => <Select.Option value={p.municipioEntradaBrasilID}>{p.nome}</Select.Option>)}

                                    </Select>
                                    {/* <Input placeholder="informe um município"
                                        disabled={permissaoUserEditar === false}
                                    /> */}
                                </Form.Item>
                            </div>


                        </div>
                        <div className="row">
                            <div className="col-md-3">
                                <Form.Item >
                                    {permissaoUserEditar === true ?
                                        <Button type="primary" htmlType="submit">Salvar</Button>
                                        : null}
                                </Form.Item>
                            </div>
                        </div>

                    </Form>
                </Spin>

            </div>
        </div >

    );

}


const mapStateToProps = (state: any) => ({
    permissao: state.permissao,
})

const mapDispatcToProps = (dispatch: any) => bindActionCreators(PermissaoAction, dispatch)

export default connect(mapStateToProps, mapDispatcToProps)(DadosImigracao);